/*
 * please follow the wiki: http://wiki.corp.qunar.com/pages/viewpage.action?pageId=105923056
 * @providesModule QImageSet
 */
'use strict';

module.exports = {
    bgTab: 'https://s.qunarzz.com/flight_shark/lowPriceRn/bg_tab.png',
    bgTabNew: 'https://s.qunarzz.com/flight_shark/lowPriceRn/tab_bg_new.png',
    cityCircle: 'https://s.qunarzz.com/flight_shark/lowPriceRn/city_switch.png',
    searchBg: 'https://s.qunarzz.com/flight_shark/lowPriceRn/search_bg_new.png',
    section1: 'https://s.qunarzz.com/flight_shark/lowPriceRn/0_70.png',
    section2: 'https://s.qunarzz.com/flight_shark/lowPriceRn/70_80.png',
    section3: 'https://s.qunarzz.com/flight_shark/lowPriceRn/80_90.png',
    section4: 'https://s.qunarzz.com/flight_shark/lowPriceRn/90_100.png',
    modal1: 'https://s.qunarzz.com/flight_shark/lowPriceRn/modal_1.png',
    modal2: 'https://s.qunarzz.com/flight_shark/lowPriceRn/modal_2.png',
    modal3: 'https://s.qunarzz.com/flight_shark/lowPriceRn/modal_3.png',
    discount: 'https://s.qunarzz.com/flight_shark/lowPriceRn/dicount.png',
    discount_bg: 'https://s.qunarzz.com/flight_shark/lowPriceRn/rank_bg.png',
    notchBg: 'https://s.qunarzz.com/flight_shark/lowPriceRn/notch_bg.jpg',
    empty: 'https://s.qunarzz.com/flight_shark/lowPriceRn/empty.png',
    leftBall: 'https://s.qunarzz.com/flight_shark/tejia/left.png',
    rightBall: 'https://s.qunarzz.com/flight_shark/tejia/right.png',
    bg: 'https://s.qunarzz.com/flight_shark/lowPriceRn/bg.jpg',
    shadowButton: 'https://s.qunarzz.com/flight_shark/lowPriceRn/shadow_button.png',
    shadowTab: 'https://s.qunarzz.com/flight_shark/lowPriceRn/shadow_tab.png',
    tabLeft: 'https://s.qunarzz.com/flight_shark/lowPriceRn/tab_left.png',
    tabRight: 'https://s.qunarzz.com/flight_shark/lowPriceRn/tab_right.png',
    tabMiddle: 'https://s.qunarzz.com/flight_shark/lowPriceRn/tab_middle.png',
    tabShadow: 'https://s.qunarzz.com/flight_shark/lowPriceRn/shadow_tab_new_1.png',
    wxBg: 'https://s.qunarzz.com/f_cms/2020/1601022378985_988653877.png'
};
